import {useProductRatingPaginationFragment} from "../../../hooks/useProductRatingPaginationFragment";
import * as React from "react";

export const ShowMoreButtonText = () => {
    const {
        model: {
            paginationModel: {
                pagination: {
                    endItemNumber,
                    totalItemCount
                }
            }
        }
    } = useProductRatingPaginationFragment();

    return (
        <span>
            Show {Math.min(totalItemCount - endItemNumber, 10)} more
        </span>
    );
};